import type { AnimationI } from "tweenly"
import { set } from "lodash"
import { UpdateNodeAnimationT } from "./animationTypes"

export const animationNode = (state: AnimationI, payload: UpdateNodeAnimationT): AnimationI => {
    return set(state, payload.property, payload.value)
}
